import { useEffect, useState } from 'react';

import { hasFeatureInLocalStorage, verifyFeatureAccess } from '../../../../global/featureFlags';

// Cached-first consumers opt into their existing first paint, then converge on the server-backed value.
// A failed check is closed so partial deploys cannot expose dark UI.
const useFeatureAccess = (featureName, allowCachedAccess = true) => {
  const [enabled, setEnabled] = useState(
    () => allowCachedAccess && hasFeatureInLocalStorage(featureName) === true,
  );

  useEffect(() => {
    let isMounted = true;
    verifyFeatureAccess(featureName).then((hasAccess) => {
      if (isMounted) setEnabled(hasAccess === true);
    }).catch(() => {
      if (isMounted) setEnabled(false);
    });

    return () => {
      isMounted = false;
    };
  }, [featureName]);

  return enabled;
};

export default useFeatureAccess;
